import {DomainName,} from '../types';
import {NavLink} from "react-router-dom";
import {
    PlatformPropertyCard,
    PlatformPropertyCardProperty,
} from "@flexinet/ui-components";
import {Stack} from "@mantine/core";


// ⚠️ FNP-1282: the prop is `formatter`, with LOWERCASE values, and it is typed
// as a discriminated union in @flexinet/ui-components. The previous code passed
// `formatAs: 'Date'` / `'Timestamp'` — a prop the library does not have — and
// `tsc` accepted it silently because `PropertyBase` has no index signature to
// reject unknown keys. All four dates rendered as raw ISO strings. The typing
// below is what makes a repeat of that a compile error rather than a silent one.
export const Profile = ({record}: { record: DomainName }) => {

    const properties: PlatformPropertyCardProperty[] = [
        {
            label: 'Name',
            value: record.name,
            span: 12,
        }, {
            label: 'Registrar',
            value: <NavLink to={`/registrars/${record.registrarId}`}>{record.registrar?.name}</NavLink>,
            span: 12,
        }, {
            label: 'Category',
            value: record.category,
            span: 12,
        }, {
            label: 'Tld',
            value: <NavLink to={`/top-level-domains/${record.tldId}`}>{record.topLevelDomain?.name}</NavLink>,
            span: 12,
        },
        {
            label: 'Purchased',
            value: record.purchaseDate,
            formatter: 'date',
            span: 12,
        },
        {
            label: 'Expiring',
            value: record.expirationDate,
            formatter: 'date',
            span: 12,
        }];

    const properties2: PlatformPropertyCardProperty[] = [
        {
            label: 'Created By',
            value: typeof record.createdBy !== 'undefined' && record.createdBy !== null ? record.createdBy.username : null,
            rbac: 'UpdateDomainName',
            span: 12,
        },
        {
            label: 'Created',
            value: record.created,
            formatter: 'timestamp',
            span: 12,
        },
        {
            label: 'Last Updated',
            value: record.updated,
            formatter: 'timestamp',
            span: 12,
        }];


    return (
        <Stack gap={'xl'}>
            <PlatformPropertyCard properties={properties}/>
            <PlatformPropertyCard properties={properties2}/>
        </Stack>
    );


};